import React from "react"
import Tabs from '../Tabs/Tabs';
import BedroomPresenterTabContent from './BedroomPresenterTabContent'
import ModalButtons from '../ModalButtons/ModalButtons'
//import I18n from "i18n-js/index.js.erb"

export default class BedroomPresenter extends React.Component {

  constructor(props) {
    super(props);
    // this.state = this.state = this.getStateFromStores()
    this.state = {
      /* ui state */
      active_tab: 'general',
      historical_view: this.props.historical_view || null,

      /* paths */
      bedroom_revision_history_path: this.props.bedroom_revision_history_path || null,

      /* fields */
      code: this.props.code ? this.props.code : null,
      name: this.props.name ? this.props.name : null,
      description: this.props.description ? this.props.description : null,
      room_size: this.props.room_size ? this.props.room_size : null,
      bed_type: this.props.bed_type ? this.props.bed_type : null,

      /* associations */
      all_amenities: this.props.all_amenities && this.props.all_amenities.length ? this.props.all_amenities : [],
      amenities: this.props.amenities && this.props.amenities.length ? this.props.amenities : [],
      image_group: this.props.image_group ? this.props.image_group : null,

      /* helpers */
      date_format: this.props.date_format || null,
      time_format: this.props.time_format || null,
      loading: false,
      
    }
    this.setActiveTab = this.setActiveTab.bind(this)
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this)
  }
  
  componentDidMount() {
    var self = this
    $(window).on("BedroomSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/bedrooms/${self.props.id}/data`,
      }).done((data) => {
        // console.log("DATA", data)
        self.setState({...data});
      })
    });
  }

  onChangeRevertVersion() {
    var self = this
    $.ajax({
      type: 'POST',
      url: `/admin/bedrooms/${this.props.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('BedroomSaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }
  

  render() {
      var buttons = [
        {
          name: I18n.t('ok'),
          html_attributes: [
              'data-dismiss="modal"'
          ]
        },
      ]
    return (
      <div className="BedroomPresenter">
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <Tabs tabs={this.tabs()}/>
          <BedroomPresenterTabContent {...this.state} />
        </div>
      </div>
    )
  }

  tabs() {
    var tabs = []

    tabs.push({
      tabName: I18n.t('general'),
      targetName: 'general',
      classes: this.state.active_tab === 'general' ? 'active' : null,
      changeHandler: this.setActiveTab,
    })

    
    
    if(this.props.historical_view == null) {
      tabs.push({
        tabName: I18n.t('amenities'),
        targetName: 'amenities',
        classes: this.state.active_tab === 'amenities' ? 'active' : null,
        changeHandler: this.setActiveTab,
      })
  
      tabs.push({
        tabName: I18n.t('images'),
        targetName: 'images',
        classes: this.state.active_tab === 'images' ? 'active' : null,
        changeHandler: this.setActiveTab,
      })
  
      tabs.push({
        tabName: I18n.t('history'),
        targetName: 'history',
        classes: this.state.active_tab === 'history' ? 'active' : null,
        changeHandler: this.setActiveTab,
      })
    }
    
    return tabs;  
  };

  setActiveTab(tab) {
    this.setState({
      active_tab: tab
    })
  }
}
